import { Trans } from '@lingui/macro'
import { TableDataContainer } from 'components/Table'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { GridContainer, NoTokensState } from 'pages/Liquidity/Table'
import { AlertTriangle } from 'react-feather'

import { useLockData, useLockStakeList } from './hooks'
import { HeaderRow, LoadedRow, LoadingRow } from './LockRow'

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer>
      <HeaderRow />
      <TableDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TableDataContainer>
    </GridContainer>
  )
}

export default function Table() {
  const { loading: loadingLocks } = useLockStakeList()

  const lockList = useLockData()
  /* loading and error state */
  if (loadingLocks && !lockList) {
    return <LoadingTokenTable rowCount={5} />
  } else if (!lockList) {
    return (
      <NoTokensState
        thRow={<HeaderRow />}
        message={
          <>
            <AlertTriangle size={16} />
            <Trans>An error occurred loading lockList. Please try again.</Trans>
          </>
        }
      />
    )
  } else if (lockList?.length === 0) {
    return <NoTokensState thRow={<HeaderRow />} message={<Trans>No lockList found</Trans>} />
  } else {
    return (
      <>
        <HeaderRow />
        <TableDataContainer>
          {lockList.map((lock, index) => (
            <LoadedRow key={lock.tokenId} lockListIndex={index} lockListLength={lockList.length} lock={lock} />
          ))}
        </TableDataContainer>
      </>
    )
  }
}
